import React from "react";
import BaseRemixModal from "@components/common/BaseRemixModal";

/**
 * RemixActivityModal - Modal for remixing activities using the shared BaseRemixModal
 */
const RemixActivityModal = ({
  isOpen,
  agenda,
  onClose,
  onRemixComplete,
  activity,
  isLoading = false,
}) => {
  return (
    <BaseRemixModal
      isOpen={isOpen}
      entity={{ ...activity, agenda }} // Pass activity with agenda context for blueprint display
      entityType="activity"
      onClose={onClose}
      onRemixComplete={onRemixComplete}
      isLoading={isLoading}
      title="What would you like to refine?"
      switchLabel="Keep same activity type"
      buttonText="✨ Remix Activity"
    />
  );
};

export default RemixActivityModal;
